import React from "react";
import TrainingLayout from "./components/training/TrainingLayout";

export default function TrainingDashboardApp() {
  return <TrainingLayout />;
}
